import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenPassword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 14,
	viewBox: "0 0 22 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8651 11C19.5892 8.79508 18.5607 6.77083 16.9711 5.30439C15.3816 3.83794 13.3394 3.02932 11.225 3.02917C9.11067 3.02902 7.06837 3.83736 5.47862 5.30358C3.88887 6.7698 2.8601 8.79391 2.58398 10.9988",
			stroke: "#5A8FC3",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2607 3.5L16.8453 0.999985",
			stroke: "#5A8FC3",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4297 6.8335L20.9988 5.51977",
			stroke: "#5A8FC3",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4297 6.8335L20.9988 5.51977",
			stroke: "#5A8FC3",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.56934 6.8335L1.00025 5.51977",
			stroke: "#5A8FC3",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5459 1L8.13046 3.50002",
			stroke: "#5A8FC3",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 10.5,
			r: 2.75,
			stroke: "#5A8FC3",
			strokeWidth: 1.5
		})
	]
});
export default SvgOpenPassword;
